import './index.scss';

import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import { Alert, Button, Container, Form, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';

import { ReactComponent as GasfloSVG } from '../../assets/Icons/Gasflow.svg';
import { validateSchema } from '../../errors/schema';
import useActions from '../../hooks/useActions';

const Login = () => {
  const { signinUser, clearError, setHeader } = useActions();
  const {
    loading,
    error,
    user,
    success,
    change_password: changePassword
  } = useSelector((state) => state.auth);

  useEffect(() => {
    return () => {
      clearError();
    };
    // eslint-disable-next-line
  }, []);

  let redirect = null;
  if (success && user?.phone) {
    // setHeader('Dashboard');
    toast.success(`Welcome ${user.lastname}`);
    redirect = <Redirect to="/" />;
  }

  let redirectChangePassword = null;
  if (changePassword) {
    // setHeader('Dashboard');
    toast.error(`You need to change your password before you can access the dashboard`);
    redirectChangePassword = <Redirect to="/request-password-reset" />;
  }

  const { values, errors, handleBlur, handleChange, handleSubmit, touched, isValid } = useFormik({
    initialValues: {
      phone: '08752423777',
      // phone: '',
      password: '12345'
      // password: ''
    },
    validationSchema: validateSchema,
    onSubmit: (formValues) => {
      signinUser(formValues.phone, formValues.password);
      setHeader('Dashboard');
    }
  });

  return (
    <>
      {redirect}
      {redirectChangePassword}
      <Container fluid className="hero-bg">
        <div className="center-container">
          <div className="hero-bg__logo">
            <GasfloSVG />
          </div>
          <Container className="mb-5 form-container">
            <Form className="pt-1" onSubmit={handleSubmit}>
              <Alert
                className="login_form_alert"
                style={{ opacity: error ? 1 : 0, height: '58px' }}
                variant="danger">
                {error}
              </Alert>

              <Form.Control
                size="md"
                type="tel"
                placeholder="Phone Number"
                className="form-Input-container"
                onChange={handleChange}
                name="phone"
                value={values.phone}
                onBlur={handleBlur}
                autoComplete="off"
                id="phone"
              />
              {errors.phone && touched.phone ? (
                <div className=" form--error">{errors.phone}</div>
              ) : null}

              <Form.Control
                size="md"
                type="password"
                placeholder="Password"
                className="form-Input-container"
                onChange={handleChange}
                name="password"
                value={values.password}
                onBlur={handleBlur}
                id="password"
              />
              <Button
                variant="primary"
                className="align-items-center mb-4 form-container--button"
                type="submit"
                disabled={!isValid || loading}>
                {loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="mr-2"
                  />
                ) : (
                  'Login'
                )}
              </Button>

              {/* <h5 className="forgot"> */}
              {/*  <Link to="/request-password-reset" className="forgot_password"> */}
              {/*    Forgot Password ? */}
              {/*  </Link> */}
              {/* </h5> */}
            </Form>
          </Container>
        </div>
      </Container>
    </>
  );
};

export default Login;
